import { get } from 'lodash';
import ChargersInfo from '../../../../../common/resources/ChargersInfo';
import TLM from '../../../../../common/resources/TLM';
import {
  AGGREGATIONS_FOR_GRAPH,
  APPEND_EVENTS_ITEM_ACTION,
  MERGE_REAL_TIME_METRICS,
  PREPEND_EVENTS_ITEM_ACTION,
  RESET_CHARGER_TM_STATE,
  SET_CHARGER_ID,
  SET_CHARGER_METRICS,
  SET_CHARGER_METRICS_BY_AGGREGATION,
  SET_CHARGER_SNAPSHOT,
  SET_EVENTS_ITEMS_ACTION,
  SET_SNAPSHOT_LOADING,
} from '../const';
import { prepareChargerMetricsToStore, prepareChargerSnapshotToStore, prepareFiltersToAPI } from '../helper';

export const setEvents = (events) => ({
  type: SET_EVENTS_ITEMS_ACTION,
  payload: events,
});

export const appendEvent = (event) => ({
  type: APPEND_EVENTS_ITEM_ACTION,
  payload: event,
});

export const prependEvent = (event) => ({
  type: PREPEND_EVENTS_ITEM_ACTION,
  payload: event,
});

export const setChargerId = (id) => ({
  type: SET_CHARGER_ID,
  payload: id,
});

export const setChargerSnapshot = (snapshot) => ({
  type: SET_CHARGER_SNAPSHOT,
  payload: snapshot,
});

export const setChargerMetrics = (metrics) => ({
  type: SET_CHARGER_METRICS,
  payload: metrics,
});

export const setChargerMetricsByAggregation = (aggregation, metrics) => ({
  type: SET_CHARGER_METRICS_BY_AGGREGATION,
  payload: { aggregation, metrics },
});

export const setSnapshotLoading = (value) => ({
  type: SET_SNAPSHOT_LOADING,
  payload: value,
});

export const resetChargerTelemetryState = () => ({
  type: RESET_CHARGER_TM_STATE,
});

const addMetricsToHistory = (metrics) => ({
  type: MERGE_REAL_TIME_METRICS,
  payload: metrics,
});

export const getChargerDetails = (chargerId) => new Promise((resolve, reject) =>
  ChargersInfo.getDetails(chargerId)
    .then(
      (response) => {
        resolve(get(response, 'data'));
      },
    )
    .catch(reject));

export const getLatestSession = (chargerId) => new Promise((resolve, reject) =>
  ChargersInfo.getSessions(
    chargerId,
    {
      page_token: 0,
      page_size: 1,
      sort_by: 'start_time',
      sort_order: 'DESC',
    },
    {
      filter_by: {},
    },
  )
    .then(
      (response) => {
        resolve(get(response, 'data.payloads[0]'));
      },
    )
    .catch(reject));

export const loadChargerSnapshot = (chargerId, {
  ok = () => {
  }, fail = () => {
  },
}) => (dispatch) => {
  dispatch(setSnapshotLoading(true));
  Promise.all([
    getChargerDetails(chargerId),
    getLatestSession(chargerId),
  ]).then(([detailsResponse, sessionResponse]) => {
    dispatch(setChargerId(chargerId));

    const { details, session } = prepareChargerSnapshotToStore(detailsResponse, sessionResponse);

    dispatch(setChargerSnapshot({
      ...details,
      session: session ? {
        ...session,
      } : null,
    }));
    dispatch(setSnapshotLoading(false));

    ok({ detailsResponse, sessionResponse });
  }).catch((error) => {
    dispatch(setSnapshotLoading(false));
    fail(error);
  });
};

export const loadChargerMetrics = (chargerId, filters, {
  ok = () => {
  }, fail = () => {
  },
}) => (dispatch) => {
  AGGREGATIONS_FOR_GRAPH.forEach((aggregation) => {
    filters.aggregation = aggregation;
    const preparedFilters = prepareFiltersToAPI({ ...filters, chargerUuids: [chargerId] });

    TLM.getTelemetry(preparedFilters)
      .then((response) => {
        const devices = get(response, 'data.devices');
        const metrics = prepareChargerMetricsToStore(chargerId, devices);

        dispatch(setChargerMetricsByAggregation(aggregation, metrics));
        ok(response);
      }).catch(fail);
  });
};

export const loadRealTimeMetrics = (chargerId, filters, isHistory = false, {
  ok = () => {
  }, fail = () => {
  },
}) => (dispatch) => {
  TLM.getChargerMetrics({
    tsFrom: filters.from,
    tsTo: filters.to,
    chargerUuids: [chargerId],
    metrics: filters.metrics.filter((item) => item !== ''),
  }).then((response) => {
    const metricsData = get(response, `data.devices[${chargerId}]`, {});
    const data = {};

    for (const metricKey in metricsData) {
      const values = metricsData[metricKey];

      for (const { sessionId, ts, value } of values) {
        if (!data[metricKey]) {
          data[metricKey] = {
            [ts]: {},
          };
        }
        data[metricKey][ts] = { ts, [metricKey]: value, sessionId };
      }
    }

    if (isHistory) {
      dispatch(setChargerMetrics(data));
    } else {
      dispatch(addMetricsToHistory(data));
    }
    ok(response);
  }).catch(fail);
};

export function convertRTMetricsForGraph(chargerId, metrics) {
  const metricObj = {};

  Object.keys(metrics).forEach((metric) => {
    metrics[metric].forEach((item) => {
      if (!metricObj[chargerId]) {
        metricObj[chargerId] = [];
      }

      const foundByTs = metricObj[chargerId] && metricObj[chargerId].find((i) => i.ts === item.ts);

      if (!foundByTs) {
        metricObj[chargerId].push({
          ts: item.ts,
          values: [{ [item.measure]: item.value }],
        });
      } else {
        foundByTs.values.push({ [item.measure]: item.value });
      }
    });
  });

  return prepareChargerMetricsToStore(chargerId, metricObj);
}
